import React, {Component} from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {useHistory} from '.react-router-dom';
import Navbar from './Components/Navbar';
import CryptoCard from './Components/CryptoCard';
import SideDrawer from './Components/SideDrawer';
import StatusDrawer from './Components/StatusDrawer';
import Backdrop from './Components/Backdrop';
import TopCap from './Components/TopCap';
import CoinId from './Components/CoinId.json';
import GaugeModal from './Components/GaugeModal';
import TradeCard from './Components/TradeCard';
import TradingViewWidget, { Themes } from 'react-tradingview-widget';
import uniswap from './Components/uniswap.jpg';
import bitcoin from './Components/bitcoin.jpg';
import ethereum from './Components/ethereum.jpg';

import {recognition} from './Components/speech/Speech';
//import { useSpeechSynthesis } from 'react-speech-kit';

//import Voice from './Components/speech/Voice';
//import Speech from 'react-speech';

import { toHaveStyle } from '@testing-library/jest-dom';

var numeral = require('numeral');
let findPrice = null;
let chosenAsset = null;
let presyo = null;
let priceText = null;
let findAsset=null;
let textMessage = '';
let UK=[];
let marketData=[];

//let history = useHistory();



recognition.start();
var apiKey = "156c5da04db8726ab5fd90a2a789e4fe78cf40307f8ac2038ae9c17532ae0624"
var ccStreamer = new WebSocket('wss://streamer.cryptocompare.com/v2?api_key=' + apiKey);
var api = "e1b4be0e5ea0e0c4716ced970599b9191f5b9078a16a15b1e45d335364543c61"
var Streamer = new WebSocket('wss://streamer.cryptocompare.com/v2?api_key=' + api); 



class App extends Component {
  constructor(props) {
    super(props);
		this.state = {
      CurrencyType: 'USDT',
      TimeFrame: 'histoday',
      currentPrice:[],
      setNumber:1,
     // Coin:['ZRX','BAT','BTC','BCH','BSV','ADA','LTC','LINK'],
      Coin:['BTC','ETH','LINK','MATIC','BNB','UNI',
      'YFI','ADA','TRX','DOT','BCH','NEO','OMG',
      'ICP','XRP','EOS','VET','LTC','ATOM',
      'FLOW','BAND','XTZ','ZEC','XMR','SUSHI',
      'CRV','GTC','ONT','XLM','SOL','ETC','SNX'],

      prevCoin:['BTC','ETH','LINK','MATIC','BNB','UNI',
      'YFI','ADA','TRX','DOT','BCH','NEO','OMG',
      'ICP','XRP','EOS','VET','LTC','ATOM',
      'FLOW','BAND','XTZ','ZEC','XMR','SUSHI',
      'CRV','GTC','ONT','XLM','SOL','ETC','SNX'],

      prevCurrency: 'USDT',
      added:[],
      sideDrawerOpen:false,
      statusDrawerOpen:false,
      //API:'156c5da04db8726ab5fd90a2a789e4fe78cf40307f8ac2038ae9c17532ae0624',
      apiKey:1,
      message:[],
      setRangeFrom:0,
      setRangeTo:16,

      open:false,
      topOpen:false,
     
     
     
      red:[],
      green:[],
      blue:[],
      locked:false,

      chartDisplay:[],
      chartDisplay_USD:[],

      newsOpen:false,
      news:[],
      loading:false,
      gaugeCoin:'',
      studies:["BB@tv-basicstudies"],

      ETH_Sentiment:[],
      BTC_Sentiment:[],
      Defi_Cap:[0],
      trade:[],
      prevTrade:[],
      tradePrice:[],
      findCoin:'',

      findPrice:null,
      priceText:null,
      marketData:[],
      tradeDetailRequest:false,
      requestSummary:false,
      

      gaugeModalOpen:false,


      checker:false,
      findCommand:false,
      openCommand:false,
      removeAsset:false,
      priceCommand:false,
      chosenTrade:false,

      assetTrade:'',
      listenEntry:'',
      listenAmount:'',
      listenTarget:'',

    


      //GOLD DIGGER PROTOCOL
      historicalTrade:[],
      executedTrade:[],
      currentGold:[],
      capital:200,
      onSpent:0,
      onTrade:false,
      activeScan:false,
      profit:0,
      removeSoldChart:[],

      ///GOLD DIGGER OPTIONS
      scanColor:'green',
      resetHistory:0,
      targetPercent:0.03, 
      tradeDuration: 5 * 60 * 1000,

      ///
      
      
      //TIMER

      time: {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      },
      duration: 10 * 60 * 1000,
      timer: null
    }


    this.startTimer = this.start.bind(this);
  }

//TIMER///
  msToTime(duration) {
    let milliseconds = parseInt((duration % 1000));
    let seconds = Math.floor((duration / 1000) % 60);
    let minutes = Math.floor((duration / (1000 * 60)) % 60);
    let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = hours.toString().padStart(2, '0');
    minutes = minutes.toString().padStart(2, '0');
    seconds = seconds.toString().padStart(2, '0');
    milliseconds = milliseconds.toString().padStart(3, '0');

    return {
      hours,
      minutes,
      seconds,
      milliseconds
    };
  }


  start() {
    if (!this.state.timer) {
      this.state.startTime = Date.now();
      this.timer = window.setInterval(() => this.run(), 10);
    }
  }

  run() {
    const diff = Date.now() - this.state.startTime;
    
    // If you want to count up
    // this.setState(() => ({
    //  time: this.msToTime(diff)
    // }));
    
    // count down
    let remaining = this.state.duration - diff;
    if (remaining < 0) {
      remaining = 0;
    }
    this.setState(() => ({
      time: this.msToTime(remaining)
    }));
    if (remaining === 0) {
      window.clearTimeout(this.timer);
      this.timer = null;

      this.listenScan()
    }
  }
//TIMER///


  getPrice(set){

let prev = this.state.prevCoin;
let prevCurrency = this.state.prevCurrency;
let x = this.state.Coin;
let m = this.state.CurrencyType;
let sets = set;

ccStreamer.onopen = function onStreamOpen() {
  
    var subRequest = {
        "action": "SubAdd",
        "subs": x.map((coin)=>("5~CCCAGG~"+coin+"~"+m))
    };
  
    ccStreamer.send(JSON.stringify(subRequest));
   
      
    
}


ccStreamer.onmessage = evt=> {
  this.setState({
    message:JSON.parse(evt.data)
  })
    var message = evt.data;  
}
//if(sets !== undefined && this.state.prevCoin !== this.state.Coin || prevCurrency !== this.state.CurrencyType){

if(sets !== undefined || prevCurrency !== this.state.CurrencyType){
 
    var subRemove = {
    "action": "SubRemove",
    "subs": prev.map((prevCoin)=>("5~CCCAGG~"+prevCoin+"~"+prevCurrency))
    
    }; 
      ccStreamer.send(JSON.stringify(subRemove));    
      
      var subRequest = {
        "action": "SubAdd",
        "subs": x.map((coin)=>("5~CCCAGG~"+coin+"~"+m))
          
    };
  
    ccStreamer.send(JSON.stringify(subRequest));  
        
  
  ccStreamer.onmessage = evt=> {
    this.setState({
      message:JSON.parse(evt.data)
    })
      var hilo = evt.data;
      //console.log("Received from Cryptocompare: " + message);
   
    
   }
  }
  this.setState({prevCoin:x})
 
}


  getCurrentPrice(){
      let url = 'https://min-api.cryptocompare.com/data/pricemulti?fsyms='+ this.state.Coin +'&tsyms=' + this.state.CurrencyType +'&api_key=156c5da04db8726ab5fd90a2a789e4fe78cf40307f8ac2038ae9c17532ae0624';
      fetch(url)
      .then(res => res.json())
      .then((data) => {
        
          if (this._isMounted){
              this.setState({currentPrice:data},()=>console.log())}
            }).catch(console.log)

  }

  
          
   
  
  changeUSD = (event)=>{
    console.log(event)
    let currency = event.target.value;
    
    if(!this.state.locked){
      this.setState({red:[],green:[],blue:[],},()=>console.log())
    }

		this.setState({
      prevCurrency:this.state.CurrencyType,
			CurrencyType: currency
        },()=>this.getPrice(this.state.setNumber))
    
  }

  

  changeSet = (event)=>{
    let set = event.target.value;

    if(!this.state.locked){
      this.setState({red:[],green:[],blue:[],},()=>console.log())
    }


    this.setState({prevCurrency:this.state.CurrencyType},()=>console.log())
    this.setState({setNumber:set},()=>console.log())
    if(set == 1){
    
    this.setState({prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
    Coin:['BTC','ETH','LINK','MATIC','BNB','UNI',
    'YFI','ADA','TRX','DOT','BCH','NEO','OMG',
    'ICP','XRP','EOS','VET','LTC','ATOM',
    'FLOW','BAND','XTZ','ZEC','XMR','SUSHI',
    'CRV','GTC','ONT','XLM','SOL','ETC','SNX']

      },()=>this.getPrice(set))
    }		

    else if(set == 2){
      this.setState({prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
      Coin:['ALGO','ANKR','ANT','BNT','CVC','TOMO',
      'SCRT','IOST','AVAX','RUNE','KAVA','ICX','ANC',
      'ENJ','MANA','COTI','OGN','MKR','POWR','QTUM',
      'HBAR','COMP','ZIL','SAND','ENS','IMX','ACH',
      'NEAR','REP','APE','WAVES','SXP']
        //Coin:['ADX','ANKR','ANT','BNT','CVC','DMT','DAI','ENG','FUNX','GNO','HNS','GNT','MCO','MET','MANA','XEM','OGN','TRAC','POWR','QTUM','SRN','SOLVE','SNT','UBT','STRAT','TUSD','USDC','PAY','REP','WAXP','WAVES','UKG']
        },()=>this.getPrice(set))
      }	
      
      else if (set == 3){
        this.setState({prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
          Coin:['DCR','FTT','NANO','TROY','WAN','BTT',
          'KSM','OCEAN','CHR','DGB','BADGER','KMD','SRM','BTS',
          'STORJ','CHZ','FIRO','FET','BLZ','RVN','MDT','SYS',
          'HIVE','LSK','WAXP','ELF','MTL','NMR','REN','GALA','BAT','LRC']
          },()=>this.getPrice(set))
        }		

      else if (set == 4) {
        this.setState({prevCoin:this.state.Coin,CurrencyType:'USDT',
          Coin:['YFII','SHIB','FIL','ALICE','LUNA','REQ',
          'AXS','KDA','DYDX','1INCH','RARE','KEY','GRT','AAVE',
          'CELR','EGLD','HOT','ARPA','THETA','KLAY','ROSE','IRIS',
          'MINA','ORN','YGG','ASTR','TRIBE','GHST','FTM','WIN','FXS','ONE']
          },()=>this.getPrice(set))
        }		
  }



  changeTime = (event)=>{
    let time = event.target.value;
    if(!this.state.locked){
      this.setState({red:[],green:[],blue:[],},()=>console.log())
    }
		this.setState({TimeFrame: time},()=>console.log())
    
  }

  
  addCoin = (coin,currency)=>{
    this.setState({added:[...this.state.added,coin+'-'+currency]},()=>console.log())
    
  }

  prevTrade = (request,coin,currency,slug)=>{
    this.setState({trade:[...this.state.trade,[request,coin,currency,slug]]},()=>this.enterTrade())
    setTimeout(()=>this.htmlFinder(request),600)
  }

   enterTrade = () =>{
      let apix = api;
      let streamer = Streamer;

     
      let prevTrade = this.state.prevTrade;
      let currentTrade = this.state.trade;
      
      streamer.onopen = function onStreamOpen() {
        
        
      var Request = {
              "action": "SubAdd",
              "subs": currentTrade.map((trade)=>("2~Binance~"+trade[0]))
          };
        
          streamer.send(JSON.stringify(Request));
         
      }
      
      streamer.onmessage = evt=> {
        this.setState({
          tradePrice:JSON.parse(evt.data)
        },()=>console.log())
          var message = evt.data;  
      }

                    /*------*/
      if(prevTrade !== this.state.trade){ 

          
          var Remove = {
          "action": "SubRemove",
          "subs": prevTrade.map((prev)=>("2~Binance~"+prev[0]))
          
          }; 
            streamer.send(JSON.stringify(Remove));    
            
            var Request = {
              "action": "SubAdd",
              "subs": currentTrade.map((trade)=>("2~Binance~"+trade[0]))
                
          };
        
          streamer.send(JSON.stringify(Request));  
              
        
        streamer.onmessage = evt=> {
      
          this.setState({
            tradePrice:JSON.parse(evt.data)
          })
            var hilo = evt.data;        
         }
        }
       
        this.setState({prevTrade:this.state.trade},()=>console.log())
      
  }


  drawerToggleClickHandler =()=>{
    this.setState((prevState)=>{
      return {sideDrawerOpen: !prevState.sideDrawerOpen, statusDrawerOpen: false};
    });
   };

   

   statusToggleClickHandler =()=>{
    this.setState((prevState)=>{
      return {statusDrawerOpen: !prevState.statusDrawerOpen, sideDrawerOpen: false};
    });
   };

   backdropClickHandler =()=>{
    this.setState({sideDrawerOpen:false,statusDrawerOpen:false});
    
   };

   clearList=()=>{
    this.setState({added:[]},()=>console.log())
   }

   nextSet=()=>{
     if(this.state.setRangeFrom == 0){
    this.setState({setRangeFrom:16,setRangeTo:32},()=>this.getPrice)
     }
   else{
    this.setState({setRangeFrom:0,setRangeTo:16},()=>this.getPrice)
   }
   }

  remove=(coinChart)=>{
    const newCharts = this.state.chartDisplay.filter(e => (e !== coinChart))
    this.setState({chartDisplay:newCharts},()=>console.log())
  }

  removeUSD=(coinChart)=>{
    console.log(coinChart)
    const USD_Chart = this.state.chartDisplay_USD.filter(e => (e[4] !== coinChart[4]))
    this.setState({chartDisplay_USD:USD_Chart},()=>console.log())
  }

 

  removeAll=()=>{
    this.setState({chartDisplay_USD:[]},()=>console.log())
  }
 

  removeTrade=(trade)=>{
    console.log(trade[0],trade[1])
    const newTrade = this.state.trade.filter(e => (e[0] !== trade[0]))
    this.setState({trade:newTrade},()=>console.log())
    
  }
  

  removeScanTrade=(trade)=>{
    console.log(trade[0],trade[1])
    const newTrade = this.state.trade.filter(e => (e[0] !== trade[0]))
    this.setState({trade:newTrade},()=>console.log())

    if(!this.state.onTrade){
      this.listenScan()
    }
    
  }

  getSlug(currency){

    if(currency === 1505){
    currency = 'USD';
  }
  else if(currency === 859){
    currency = 'BTC';
  }
  else if(this.props.currency === 145){
    currency = 'ETH';
    }
  
    
    return currency;
    
}


changeKey=(event)=>{
  let key = event.target.value
  this.setState({apiKey:key},()=>this.changeApi())  
}

changeScanColor=(event)=>{
  let color = event.target.value
  this.setState({scanColor:color},()=>console.log(this.state.scanColor))  
}

changeTarget=(event)=>{
  let targetPercent = event.target.value
  this.setState({targetPercent:targetPercent},()=>console.log(this.state.targetPercent))  
}

changeReset=(event)=>{
  let reset = event.target.value
  this.setState({resetHistory:reset},()=>console.log(this.state.resetHistory))  
}

changeTradeDuration=(event)=>{
  let duration = event.target.value
  this.setState({tradeDuration:duration},()=>console.log(this.state.tradeDuration))  
}




changeApi=()=>{
  if(this.state.apiKey == 1){
    apiKey = "156c5da04db8726ab5fd90a2a789e4fe78cf40307f8ac2038ae9c17532ae0624"
    ccStreamer = new WebSocket('wss://streamer.cryptocompare.com/v2?api_key=' + apiKey);
    
  }
  else if(this.state.apiKey == 2){
    apiKey = "c0de896bb4dc62341cd2590ab7cd8a3231e7614493cd395852d41c7cdd9f293d"
    ccStreamer = new WebSocket('wss://streamer.cryptocompare.com/v2?api_key=' + apiKey);
  }

  else if(this.state.apiKey == 3){
    apiKey = "e1b4be0e5ea0e0c4716ced970599b9191f5b9078a16a15b1e45d335364543c61"
    ccStreamer = new WebSocket('wss://streamer.cryptocompare.com/v2?api_key=' + apiKey);
  }
  setTimeout(()=>this.getPrice(this.state.setNumber),2000)
}

getNews=()=>{
  
  if(this.state.newsOpen){
  fetch('https://api.coingecko.com/api/v3/status_updates??project_type=coin&per_page=60')
  .then(res => res.json())
  .then((data) => {
    if (this._isMounted){
      this.setState({news:data.status_updates,loading:false},()=>(console.log()))}

  })
  .catch(console.log)}
  else this.getPrice(this.state.setNumber)

}

newsOpen=()=>{
  this.setState({loading:true},()=>console.log())
  this.setState((prevState)=>{
    return {newsOpen: !prevState.newsOpen};
  },()=>this.getNews()); 

}

getRSI(){
  fetch('https://www.alphavantage.co/query?function=RSI&symbol=WAVESBTC&interval=daily&time_period=14&series_type=close&apikey=ZHCR5B7KFCZ0EONE')
  .then(res => res.json())
  .then((data) => {
  
console.log('RSI',data)
  })
  .catch(console.log)
  //else this.getPrice(this.state.setNumber)
}


getSentiment(){
  
  fetch('https://min-api.cryptocompare.com/data/tradingsignals/intotheblock/latest?fsym=BTC&api_key=e1b4be0e5ea0e0c4716ced970599b9191f5b9078a16a15b1e45d335364543c61')
  .then(res => res.json())
  .then((data) => {
    console.log(data)
this.setState({BTC_Sentiment:data.Data.largetxsVar},()=>console.log(this.state.BTC_Sentiment))
  })
  .catch(console.log)

  fetch('https://min-api.cryptocompare.com/data/tradingsignals/intotheblock/latest?fsym=ETH&api_key=e1b4be0e5ea0e0c4716ced970599b9191f5b9078a16a15b1e45d335364543c61')
  .then(res => res.json())
  .then((data) => {
    console.log(data)
this.setState({ETH_Sentiment:data.Data.largetxsVar},()=>console.log(this.state.ETH_Sentiment))
  })
  .catch(console.log)

  fetch('https://api.coingecko.com/api/v3/global/decentralized_finance_defi')
  .then(res => res.json())
  .then((data) => {
    if (this._isMounted){
      this.setState({Defi_Cap:data.data.defi_market_cap},()=>(console.log(data)))}

  })
  .catch(console.log)
 
}


findingCoin = (event) => {
  let find= event.target.value;
  this.setState({findCoin:find},()=>console.log())
}


free(){ 
  document.querySelector('button').click();
var msg = new SpeechSynthesisUtterance('Test');
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = 'Hello World';    
   u.lang = 'en-US';
   u.rate = 1;
   u.pitch = .9;       
   speechSynthesis.speak(u);

  }

//








//SPEAK MESSAGE//

listenUSD = (event, message)=>{
  textMessage = message
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;    
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = .9; 
   u.voice = UK;      
   speechSynthesis.speak(u);

  let currency = event;

  if(!this.state.locked){
    this.setState({red:[],green:[],blue:[],},()=>console.log())
  }

  this.setState({
    prevCurrency:this.state.CurrencyType,
    CurrencyType: currency
      },()=>this.getPrice(this.state.setNumber))
  
}


drawerOpen =(event)=>{

  textMessage = event;
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage; 
     u.lang = 'en-US';   
     u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);
  this.setState({statusDrawerOpen:true},()=>this.speakStatus())
 };

 drawerClose =(event)=>{
  textMessage = event;
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage; 
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);
  this.setState({statusDrawerOpen:false},()=>console.log())
 };

speakStatus(){
if(this.state.green.length === 0 && this.state.blue.length === 0){
  textMessage = 'sorry captain, but there are no signals for the assets at the moment';
}
else{
  textMessage = 'We identified '+ this.state.green.length + 'assets, signaling green, and '+ this.state.blue.length + 'assets, signaling blue';
}
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage; 
     u.lang = 'en-US';   
     u.rate = 1;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);
  
 };

 listenTime = (event, message)=>{

  textMessage = message
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage; 
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);
  let time = event

  if(!this.state.locked){
    this.setState({red:[],green:[],blue:[],},()=>console.log())
  }

  this.setState({TimeFrame: time},()=>console.log())
  
  
}

speakPrice = (coin, price)=>{


  priceText = 'the price of ' + coin + ', is ' + price + ' dollars';
  findPrice = null; 
 // useSpeechSynthesis(priceText);
  //speak({})
  console.log(priceText, findPrice)   
  
  textMessage = priceText
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;   
     u.lang = 'en-US';   
     u.rate = .9;
   u.pitch = .9; 
   u.voice = UK;      
   speechSynthesis.speak(u);

     

}

affirmative = (coin)=>{
  textMessage = 'Yes Captain, Opening the chart of ' + coin
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage; 
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = .9; 
     u.voice = UK;      
     speechSynthesis.speak(u);
    
}

showTop = ()=>{
  textMessage = 'Checking Top Cryptocurrencies'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage; 
     u.lang = 'en-US';   
     u.rate = .9;
   u.pitch = .9; 
   u.voice = UK;      
   speechSynthesis.speak(u);
    
}

closeTop = ()=>{
  textMessage = 'Closing the modal'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
   u.pitch = .9; 
   u.voice = UK;      
   speechSynthesis.speak(u);
    
}


removingChart = ()=>{
  textMessage = 'Removing Chart'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;   
     u.lang = 'en-US';   
     u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);
    
}

listenSet = (event)=>{
  let set = event;

  textMessage = 'i am changing the sets'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;  
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = .9; 
   u.voice = UK;      
   speechSynthesis.speak(u);


  if(!this.state.locked){
    this.setState({red:[],green:[],blue:[],},()=>console.log())
  }

  this.setState({prevCurrency:this.state.CurrencyType},()=>console.log())
  this.setState({setNumber:set},()=>console.log())
  if(set == 1){
  
  this.setState({prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
  Coin:['BTC','ETH','LINK','MATIC','BNB','UNI',
  'YFI','ADA','TRX','DOT','BCH','NEO','OMG',
  'ICP','XRP','EOS','VET','LTC','ATOM',
  'FLOW','BAND','XTZ','ZEC','XMR','SUSHI',
  'CRV','GTC','ONT','XLM','SOL','ETC','SNX']

    },()=>this.getPrice(set))
  }		

  else if(set == 2){
    this.setState({prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
    Coin:['ALGO','ANKR','ANT','BNT','CVC','TOMO',
    'SCRT','IOST','AVAX','RUNE','KAVA','ICX','ANC',
    'ENJ','MANA','COTI','OGN','MKR','POWR','QTUM',
    'HBAR','COMP','ZIL','SAND','ENS','IMX','ACH',
    'NEAR','REP','APE','WAVES','SXP']

      },()=>this.getPrice(set))
    }	
    
    else if (set == 3){
      this.setState({prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
        Coin:['DCR','FTT','NANO','TROY','WAN','BTT',
        'KSM','OCEAN','CHR','DGB','BADGER','KMD','SRM','BTS',
        'STORJ','CHZ','FIRO','FET','BLZ','RVN','MDT','SYS',
        'HIVE','LSK','WAXP','ELF','MTL','NMR','REN','GALA','BAT','LRC']
        },()=>this.getPrice(set))
      }		

    else if (set == 4) {
      this.setState({prevCoin:this.state.Coin,CurrencyType:'USDT',
        Coin:['YFII','SHIB','FIL','ALICE','LUNA','REQ',
        'AXS','KDA','DYDX','1INCH','RARE','KEY','GRT','AAVE',
        'CELR','EGLD','HOT','ARPA','THETA','KLAY','ROSE','IRIS',
        'MINA','ORN','YGG','ASTR','TRIBE','GHST','FTM','WIN','FXS','ONE']
        },()=>this.getPrice(set))
      }		
}



listenScan = ()=>{
 // let set = event;
  let comment = 'Market Scan.Complete';
  this.setState({locked:false,activeScan:true},()=>console.log())

  textMessage = 'Scanning the market'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;  
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);

   
  textMessage = 'Locking all signals.'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;  
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);

    
  textMessage = 'this may take a while'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;  
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);



  this.setState({red:[],green:[],blue:[],
    prevCurrency:this.state.CurrencyType,
      },()=>console.log())
 // this.setState({setNumber:set},()=>console.log())
  
 
  	
    this.setState({set:4,prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
    Coin:['YFII','SHIB','FIL','ALICE','LUNA','REQ',
    'AXS','KDA','DYDX','1INCH','RARE','KEY','GRT','AAVE',
    'CELR','EGLD','HOT','ARPA','THETA','KLAY','ROSE','IRIS',
    'MINA','ORN','YGG','ASTR','TRIBE','GHST','FTM','WIN','FXS','ONE']
      },()=>this.getPrice(4))


    setTimeout(()=>this.setState({set:2,prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
    Coin:['ALGO','ANKR','ANT','BNT','CVC','TOMO',
    'SCRT','IOST','AVAX','RUNE','KAVA','ICX','ANC',
    'ENJ','MANA','COTI','OGN','MKR','POWR','QTUM',
    'HBAR','COMP','ZIL','SAND','ENS','IMX','ACH',
    'NEAR','REP','APE','WAVES','SXP']
      //Coin:['ADX','ANKR','ANT','BNT','CVC','DMT','DAI','ENG','FUNX','GNO','HNS','GNT','MCO','MET','MANA','XEM','OGN','TRAC','POWR','QTUM','SRN','SOLVE','SNT','UBT','STRAT','TUSD','USDC','PAY','REP','WAXP','WAVES','UKG']
      },()=>this.getPrice(2)),30000)
    
    
  
    setTimeout(()=>this.setState({set:3,prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
        Coin:['DCR','FTT','NANO','TROY','WAN','BTT',
        'KSM','OCEAN','CHR','DGB','BADGER','KMD','SRM','BTS',
        'STORJ','CHZ','FIRO','FET','BLZ','RVN','MDT','SYS',
        'HIVE','LSK','WAXP','ELF','MTL','NMR','REN','GALA','BAT','LRC']
        },()=>this.getPrice(3)),60000)
      		
 
    setTimeout(()=> this.setState({set:1,prevCoin:this.state.Coin,CurrencyType:this.state.CurrencyType,
          Coin:['BTC','ETH','LINK','MATIC','BNB','UNI',
          'YFI','ADA','TRX','DOT','BCH','NEO','OMG',
          'ICP','XRP','EOS','VET','LTC','ATOM',
          'FLOW','BAND','XTZ','ZEC','XMR','SUSHI',
          'CRV','GTC','ONT','XLM','SOL','ETC','SNX']
        
            },()=>this.getPrice(1)),90000)
        
   setTimeout(()=>this.compeleteScan(),100000)
   
}

compeleteScan(){
  this.setState({locked:true,activeScan:false},()=>console.log())
  let  textMessage = 'Market Scan.Complete. All signals are locked'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;  
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);

  /*if(!this.state.statusDrawerOpen){
   this.drawerOpen("showing status")
   setTimeout(()=>this.goldDigger(),3000)
  }
  else{
    this.speakStatus()
    setTimeout(()=>this.goldDigger(),3000)
  }*/
  this.speakStatus()
  setTimeout(()=>this.goldDigger(),3000)
}

goldDigger(){
 let scanSignal = this.state.scanColor
  //scanColor:'green',
      
if(this.state.executedTrade.length > this.state.resetHistory){
  this.setState({executedTrade:[]},()=>console.log())
}

if(this.state.scanColor === 'red'){
  scanSignal = this.state.red
}
else if(this.state.scanColor === 'blue'){
  scanSignal = this.state.blue
}
else{
  scanSignal = this.state.green
}
 // var fullWordList = ['1','2','3','4','5'];
//var wordsToRemove = ['1','2','3'];
console.log('GOLD DIGER',this.state.profit,this.state.onSpent,this.state.capital)
let filter =  scanSignal.filter((coin) => !this.state.executedTrade.includes(coin[0]));

console.log(filter);
 // prevTrade = (request,coin,currency,slug)=>{
  //  this.setState({trade:[...this.state.trade,[request,coin,currency,slug]]},()=>this.enterTrade())
 // }
  //this.props.prevTrade((this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,coinSlug,this.state.twitter)
  let sorts = filter.sort((a,b)=>b[1] - a[1])

  //console.log('sdsds',sorts, sorts[0][0])
  if(sorts.length > 0 && !this.state.onTrade && this.state.capital > 0){
    console.log('sdsds',sorts, sorts[0][0])


  let  textMessage = 'Entering' + sorts[0][0].slice(0, -4);
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u);



  this.setState({executedTrade:[...this.state.executedTrade,sorts[0][0]],
    onTrade:true,
    currentGold:sorts[0][0],
    onSpent:this.state.capital,
    capital:0,
    trade:[...this.state.trade,[sorts[0][4],sorts[0][5],sorts[0][6],sorts[0][7],sorts[0][8]]]},()=>setTimeout(()=>this.enterTrade(),3000))
    this.state.chartDisplay_USD.push([sorts[0][7],'USDT',(sorts[0][5] + 'USDT'),false,sorts[0][5]]);
    
    setTimeout(()=>this.htmlFinder(sorts[0][4]),600)
    console.log(this.state.executedTrade,this.state.trade)
  }
  else{

    
  let  textMessage = 'Captain, it looks like the shitcoins are shitting the shit at the moment. I will try scanning again after 10 minutes.';
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;  
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u);

    this.startTimer()
  }

}

sell=(name,sold,entry,amount,closeTrade,minutes,seconds)=>{
  console.log('sold',name,entry,sold,amount)
  this.state.historicalTrade.push([name,sold,entry,amount,closeTrade,minutes,seconds])
    console.log(this.state.historicalTrade)


    let  textMessage = 'We have sold' + name + ' with a profit of' + numeral(sold-this.state.onSpent).format('0,0.00') +'$'
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u);
    
  this.setState({profit:sold-this.state.onSpent,onTrade:false,capital:sold,onSpent:0},()=>setTimeout(()=>this.removeScanTrade([closeTrade,5]),3000)
  ) 
  setTimeout(()=>this.removeUSD([null,null,null,null,name.slice(0, -5)]),2500)
}



tagalogChart(coinCharts){
  
  if(!this.state.checker){   
  
      textMessage = 'sorry captain but,' + coinCharts + ' is not on our list'
      var u = new SpeechSynthesisUtterance('All is Ok');
       u.text = textMessage;  
       u.lang = 'en-US';   
       u.rate = .9;
       u.pitch = 1; 
       u.voice = UK;      
       speechSynthesis.speak(u)
      }

      else{
        let x = coinCharts.ID
        let slug = coinCharts.slug +'-USDT'
        if(x !== undefined)
        this.state.chartDisplay_USD.push([coinCharts.slug,'USDT',(coinCharts.name + 'USDT'),false,coinCharts.name]);
        console.log(coinCharts)
        this.affirmative(coinCharts.ID)      
        //setTimeout(()=>window.scrollTo(0,680),500); 
        setTimeout(()=>this.htmlFinder((coinCharts.name+'XUSDT')),600)
      }
    
  this.setState({openCommand:false},()=>console.log())
}







tagalogPrice(coinChart){
  //recognition.stop();

  if(!this.state.checker){   
  
      textMessage = 'sorry captain, there is no data for ' + coinChart
      var u = new SpeechSynthesisUtterance('All is Ok');
       u.text = textMessage;  
       u.lang = 'en-US';   
       u.rate = .9;
       u.pitch = 1; 
       u.voice = UK;      
       speechSynthesis.speak(u)
      }
      else{
        //let x = ID[0].ID
   // console.log(x)
    //if(x !== undefined)
    //'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd'
    fetch('https://api.coingecko.com/api/v3/simple/price?ids='+coinChart.ID+'&vs_currencies=usd')
    .then(res => res.json())
    .then((data) => {
  
      if (this._isMounted && data !== undefined){
      this.setState({marketData:data[[coinChart.ID]].usd},()=>(console.log(this.state.marketData)))}
  
      textMessage = 'the price of '+ coinChart.ID + ',is ' + this.state.marketData + ' dollars'
      var u = new SpeechSynthesisUtterance('All is Ok');
       u.text = textMessage;  
       u.lang = 'en-US';   
       u.rate = .9;
       u.pitch = 1; 
       u.voice = UK;      
       speechSynthesis.speak(u)
    
      })
    .catch(console.log)
      }
    
    
  this.setState({priceCommand:false},()=>console.log())
}



speakTrade(){
  if(this.state.trade.length === 0){
  textMessage = 'sorry captain, you do not have an open position at the moment.'
  var u = new SpeechSynthesisUtterance('All is Ok');
   u.text = textMessage;  
   u.lang = 'en-US';   
   u.rate = .9;
   u.pitch = 1; 
   u.voice = UK;      
   speechSynthesis.speak(u)

  }
  else{
    if(this.state.trade.length === 1){
    textMessage = 'Captain, you currently have ' + this.state.trade.length + 'open position on ' + this.state.trade[0][1].toLowerCase() + ' USD'  
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)
    }
    else{

    textMessage = 'Captain you currently have ' + this.state.trade.length + 'open position on '  
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)

     for(var i = 0; i < this.state.trade.length; i++){
      textMessage = this.state.trade[i][1].toLowerCase() + ' USD'  
      var u = new SpeechSynthesisUtterance('All is Ok');
       u.text = textMessage;  
       u.lang = 'en-US';   
       u.rate = .9;
       u.pitch = 1; 
       u.voice = UK;      
       speechSynthesis.speak(u)
     }
    }
  }
}



speakTradeDetails = (detail, name, currency, percent) =>{
 
   let spent = numeral(detail.asset * detail.entry).format('0,0.00') 
   let currentworth = numeral(detail.asset * detail.price).format('0,0.00')
   let currentloss = numeral((detail.asset * detail.price) - (detail.asset * detail.entry)).format('0,0.00')

   let profit = '';
   let direction = '';
   let comment = '';
   
   if(numeral(percent).format('0,0.00') < 0){
   profit = 'loss is, '
   direction = 'down '
   comment = ' you. are. rekt.  idiot fucker'
  }
    else{
      profit = 'gain is, '
      direction = 'up '
      comment = ' great job captain! tooda moon!'
     }

    textMessage = 'captain, you are '+ direction + numeral(percent).format('0,0.0') +' % on, '+ name.toUpperCase()
   // captain, you are holding 1720 dollars worth of bnb. you have bought 4 bnb at 556 dollars each totaling to 2224 dollars, 
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)


     textMessage = 'you are holding '+ numeral(currentworth).format('0,0')+ '$ worth of '+ name.toUpperCase() 
   // captain, you are holding 1720 dollars worth of bnb. you have bought 4 bnb at 556 dollars each totaling to 2224 dollars, 
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)

    textMessage = 'you have bought,'+ numeral(detail.asset).format('0,0') +' '+ name.toUpperCase() + ', at '+ numeral(detail.entry).format('0,0.00') +' $ each totaling to '+ numeral(spent).format('0,0') +'$'
   // captain, you are holding 1720 dollars worth of bnb. you have bought 4 bnb at 556 dollars each totaling to 2224 dollars, 
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)

      textMessage = 'the current price of ' + name.toUpperCase() + ' is. ' + numeral(detail.price).format('0,0.00')  +' $. which means,your unrealized '+ profit + numeral(currentloss).format('0,0') + 'dollats.' + comment
      var u = new SpeechSynthesisUtterance('All is Ok');
       u.text = textMessage;  
       u.lang = 'en-US';   
       u.rate = .9;
       u.pitch = 1; 
       u.voice = UK;      
       speechSynthesis.speak(u)
  

  
  this.setState({tradeDetailRequest:false},()=>console.log());
}


summaryRequest = (detail, name, currency, percent) =>{
 
  let spent = numeral(detail.asset * detail.entry).format('0,0.00') 
  let currentworth = numeral(detail.asset * detail.price).format('0,0.00')
  let currentloss = numeral((detail.asset * detail.price) - (detail.asset * detail.entry)).format('0,0.00')

  let profit = '';
  let direction = 'pending';
  let comment = '';
  
  if(numeral(percent).format('0,0.00') < 0){
  profit = 'loss is, '
  direction = 'down '

  if(numeral(percent).format('0,0.00') < -10){
    comment = ' you might want to reconsider this position'
   }
 }
   else if(numeral(percent).format('0,0.00') > 0){
     profit = 'gain is, '
     direction = 'up '
     //comment = ' great job captain! tooda moon!'
    }

   textMessage = 'captain, you are '+ direction + numeral(percent).format('0,0.0').replaceAll('-','') +' % on. '+ name.toUpperCase()
  // captain, you are holding 1720 dollars worth of bnb. you have bought 4 bnb at 556 dollars each totaling to 2224 dollars, 
   var u = new SpeechSynthesisUtterance('All is Ok');
    u.text = textMessage;  
    u.lang = 'en-US';   
    u.rate = .9;
    u.pitch = 1; 
    u.voice = UK;      
    speechSynthesis.speak(u)

 this.setState({requestSummary:false},()=>console.log());
}


sinongGreen(){
  if(this.state.green.length === 0){
    textMessage = 'sorry captain,there are no assets signaling green at the moment'
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)
  }
  else{
    textMessage = 'the assets signaling green are'
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)

  for(var i = 0; i < this.state.green.length; i++){
    textMessage = this.state.green[i][0]
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)
   }
  }
}

sinongBlue(){
  if(this.state.blue.length === 0){
    textMessage = 'sorry captain,there are no assets signaling blue at the moment'
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)
  }
  else{
    textMessage = 'the assets signaling blue are'
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)

  for(var i = 0; i < this.state.blue.length; i++){
    textMessage = this.state.blue[i][0]
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)
   }
  }
}



/*findAsset(asset,currency){

  let ID = CoinId.filter(coins => coins.keyword === asset)
  console.log(ID)
  if(ID.length === 0){

    let ID = CoinId.filter(coins => coins.name === asset.toUpperCase())


    if(ID.length === 0){

      let ID = CoinId.filter(coins => coins.ID === asset.toString().replaceAll(' ', '-'))


    if(ID.length === 0){

    textMessage = 'sorry captain, there is no data for ' + asset
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)
    }
    else{
      
      let x = ID[0].name+'-'+currency;
      console.log(document.getElementById(x.toString()))
    
      if(document.getElementById(x.toString())){

     textMessage = 'looking for ' + ID[0].ID
     var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)

        document.getElementById(x.toString().toUpperCase()).scrollIntoView({
          behavior: 'smooth'
        });
      }
      else{

          textMessage = 'Captain, ' + ID[0].ID + ' is on list number ' + ID[0].list
          var u = new SpeechSynthesisUtterance('All is Ok');
          u.text = textMessage;  
          u.lang = 'en-US';   
          u.rate = .9;
          u.pitch = 1; 
          u.voice = UK;      
          speechSynthesis.speak(u)  
      }
    }

    }
    else{
      
      let x = ID[0].name+'-'+currency;
      console.log(document.getElementById(x.toString()))
    
      if(document.getElementById(x.toString())){

     textMessage = 'looking for ' + ID[0].ID
     var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)

        document.getElementById(x.toString().toUpperCase()).scrollIntoView({
          behavior: 'smooth'
        });
      }
      else{

          textMessage = 'Captain, ' + ID[0].ID + ' is on list number ' + ID[0].list
          var u = new SpeechSynthesisUtterance('All is Ok');
          u.text = textMessage;  
          u.lang = 'en-US';   
          u.rate = .9;
          u.pitch = 1; 
          u.voice = UK;      
          speechSynthesis.speak(u)  
      }
    }
  }
  
  else{

  let x = ID[0].name+'-'+currency;
  console.log(document.getElementById(x.toString()))

  if(document.getElementById(x.toString())){

    textMessage = 'looking for ' + ID[0].ID
    var u = new SpeechSynthesisUtterance('All is Ok');
    u.text = textMessage;  
    u.lang = 'en-US';   
    u.rate = .9;
    u.pitch = 1; 
    u.voice = UK;      
    speechSynthesis.speak(u)

    document.getElementById(x.toString().toUpperCase()).scrollIntoView({
      behavior: 'smooth'
    });
   
    }
    else{

      textMessage = 'Captain, ' + ID[0].ID + ' is on list number ' + ID[0].list
      var u = new SpeechSynthesisUtterance('All is Ok');
      u.text = textMessage;  
      u.lang = 'en-US';   
      u.rate = .9;
      u.pitch = 1; 
      u.voice = UK;      
      speechSynthesis.speak(u)
             
  }
  }

}*/

htmlFinder(x){
   
  if(document.getElementById(x)){
    document.getElementById(x.toString().toUpperCase()).scrollIntoView({
      behavior: 'smooth'
    });
  }
}


speakRemoveUSD = (coinChart) =>{
 console.log(coinChart)
  if(!this.state.checker){   
  textMessage = 'Sorry Captain, ' + coinChart + ' is not on our list.'
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)
  }     
  else{

    let currentLength = this.state.chartDisplay_USD.length;
    console.log(coinChart)
    const USD_Chart = this.state.chartDisplay_USD.filter(e => (e[4] !== coinChart.name))
    this.setState({chartDisplay_USD:USD_Chart},()=>console.log())


    if(currentLength !== 0 && this.state.chartDisplay_USD.length < currentLength){
          textMessage = 'Closing the chart of ' + coinChart.ID
          var u = new SpeechSynthesisUtterance('All is Ok');
          u.text = textMessage;  
          u.lang = 'en-US';   
          u.rate = .9;
          u.pitch = 1; 
          u.voice = UK;      
          speechSynthesis.speak(u)
    }
    else{
      textMessage = 'Captain, the chart of ' + coinChart.ID +' is not currently open.'
          var u = new SpeechSynthesisUtterance('All is Ok');
          u.text = textMessage;  
          u.lang = 'en-US';   
          u.rate = .9;
          u.pitch = 1; 
          u.voice = UK;      
          speechSynthesis.speak(u)
     }  

    }
  this.setState({removeAsset:false},()=>console.log())
  
}


findAsset(coinChart){

    if(!this.state.checker){   
    textMessage = 'sorry captain, there is no data for ' + coinChart
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)
      }
    else{
      
      let x = coinChart.name+'-'+this.state.CurrencyType;
     // console.log(document.getElementById(x.toString()))
    
      if(document.getElementById(x.toString())){

     textMessage = 'looking for ' + coinChart.ID
     var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u)

        document.getElementById(x.toString().toUpperCase()).scrollIntoView({
          behavior: 'smooth'
        });
      }
      else{

          textMessage = 'Captain, ' + coinChart.ID + ' is on list number ' + coinChart.list
          var u = new SpeechSynthesisUtterance('All is Ok');
          u.text = textMessage;  
          u.lang = 'en-US';   
          u.rate = .9;
          u.pitch = 1; 
          u.voice = UK;      
          speechSynthesis.speak(u)  
      }
    }

  
  this.setState({findCommand:false},()=>console.log())
    
}


populate(asset){
  if(!this.state.checker){
  textMessage = 'sorry captain, there is no data for ' + asset
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)
  }

  else{

  this.setState({assetTrade:asset.name},()=>console.log())
  textMessage = 'I am ready, goodluck captain.'
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)
  }
  this.setState({chosenTrade:false},()=>console.log())

}

abort(){
  
  speechSynthesis.cancel()
  this.sorry()
}

motoko(){

  let trades = 'trade.';
  if(this.state.historicalTrade.length > 1){
    trades = 'different trades.'
  }
  textMessage = 'Captain, We have a total profit of. ' + numeral(this.state.profit).format('0,0.00') + '$ executed from. '+ this.state.historicalTrade.length + trades + ' We also have an available balance of. ' + numeral(this.state.capital).format('0,0.00')+'$ and,' + numeral(this.state.onSpent).format('0,0.0')+'$ on an open position.'
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)
 
}


sorry(){
  textMessage = 'sorry captain'
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)
}

unlock(){
  
  textMessage = 'it is allways unlocked for you captain'
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)

}

oblivion(){
  textMessage = 'i got you captain..., lets pump this shit to oblivion....'
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)
}

clearMind(){
  
  textMessage = 'Activating Clear Mind Protocol'
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)

  setTimeout(()=>this.setState({chartDisplay_USD:[],trade:[]},()=>console.log()),2000)
}


bigBang(){
  
  textMessage = 'Activating Big Bang Protocol'
  var u = new SpeechSynthesisUtterance('All is Ok');
  u.text = textMessage;  
  u.lang = 'en-US';   
  u.rate = .9;
  u.pitch = 1; 
  u.voice = UK;      
  speechSynthesis.speak(u)
  window.location.reload(false);
}









checker(coin){

  if(coin.length !== 0 && coin.length < 25){
  let ID = CoinId.filter(coins => coins.keyword === coin)
  console.log(ID)
  if(ID.length === 0){

    let ID = CoinId.filter(coins => coins.name === coin.toUpperCase())


    if(ID.length === 0){
      let dash = coin.replaceAll(' ', '-')
      let ID = CoinId.filter(coins => coins.ID === dash)

      if(ID.length === 0){
  
        let x = coin
        this.setState({checker:false},()=>console.log())
        console.log(x)
         
        if(this.state.removeAsset){
          this.speakRemoveUSD(x)
          }

        
        if(this.state.findCommand){
          this.findAsset(x)
          }

        if(this.state.openCommand){
          this.tagalogChart(x)
          }

        if(this.state.priceCommand){
          this.tagalogPrice(x)
          }

        
        if(this.state.chosenTrade){
          this.populate(x)
          }
  
     
      }
      else{
        let x = ID[0]
        console.log(x)
        this.setState({checker:true},()=>console.log())
        
        
        if(this.state.removeAsset){
          this.speakRemoveUSD(x)
          }
       
        if(this.state.findCommand){
          this.findAsset(x)
          }

        if(this.state.openCommand){
          this.tagalogChart(x)
          }

        if(this.state.priceCommand){
          this.tagalogPrice(x)
          }

        if(this.state.chosenTrade){
          this.populate(x)
          }
      }
    
    
    }
    else{
      let x = ID[0]
        console.log(x)
        this.setState({checker:true},()=>console.log())
                
        if(this.state.removeAsset){
          this.speakRemoveUSD(x)
          }
        
        if(this.state.findCommand){
          this.findAsset(x)
          }

        if(this.state.openCommand){
          this.tagalogChart(x)
          }

        if(this.state.priceCommand){
          this.tagalogPrice(x)
          }

        if(this.state.chosenTrade){
          this.populate(x)
          }
    }
  }
  

  else{

    let x = ID[0]
    console.log(x)
    this.setState({checker:true},()=>console.log())
   
    if(this.state.removeAsset){
      this.speakRemoveUSD(x)
      }
  
    if(this.state.findCommand){
      this.findAsset(x)
      }

    if(this.state.openCommand){
      this.tagalogChart(x)
      }

    if(this.state.priceCommand){
      this.tagalogPrice(x)
      }

    if(this.state.chosenTrade){
      this.populate(x)
      }
   
  }
}
}











  render(){

    //START OF COMMANDS
    recognition.onresult = (event) =>{
      console.log(event)
        const command = event.results[0][0].transcript;
        console.log(command)
        
        //if(command.includes("gideon")){
        //CHANGE CURRENCY
          //console.log(command)
          if(command.includes("check bitcoin") || command.includes("show bitcoin") || command.includes("check btc") || command.includes("show btc")){
            this.listenUSD('BTC','checking assets against bitcoin')
          }

          if(command.includes("check dollar") || command.includes("show dollar") || command.includes("check usd") || command.includes("show dollar")){
            this.listenUSD('USDT','checking assets against dollar')
          }

          
          if(command.includes("check eth") || command.includes("show eth") || command.includes("check either") || command.includes("show either")){
            this.listenUSD('ETH','checking assets against ethereum')
          }

           
          if(command.includes("check ourly") || command.includes("show ourly") || command.includes("check hourly") || command.includes("show hourly") || (command.includes("check early") || command.includes("show early"))){
            this.listenTime('histohour', 'checking hourly signals')
          }

          if(command.includes("check daily") || command.includes("show daily") || command.includes("check dayli") || command.includes("show dayli")){
            this.listenTime('histoday','checking daily signals')
          }

          //SIGNAL
          if(command.includes("signal")){
            this.speakStatus()
          }

          if(command.includes("scan")){
            if(this.state.activeScan){
              textMessage = 'sorry captain, but there is allready an active scan procedure.'
              var u = new SpeechSynthesisUtterance('All is Ok');
               u.text = textMessage;  
               u.lang = 'en-US';   
               u.rate = .9;
               u.pitch = 1; 
               u.voice = UK;      
               speechSynthesis.speak(u); 
            }
            else {
            textMessage = 'Roger that captain.'
            var u = new SpeechSynthesisUtterance('All is Ok');
             u.text = textMessage;  
             u.lang = 'en-US';   
             u.rate = .9;
             u.pitch = 1; 
             u.voice = UK;      
             speechSynthesis.speak(u);

            this.listenScan()
            }
          }

          if(command.includes("unlock")){
            this.setState({locked:false},()=>this.unlock())
          }

          if(command.includes("sinong green")||command.includes("sinong dream")||command.includes("sinong grim")){
            this.sinongGreen()
          }

          if(command.includes("sinong blue")||command.includes("sinong blu")||command.includes("sinong bloop")){
            this.sinongBlue()
          }


          //CHANGE SET
          if(command.includes("set")){
          if(command.includes("1") || command.includes("one") || command.includes("wan")){
            this.listenSet('1')
          }

          if(command.includes("2") || command.includes("two") || command.includes("to") || command.includes("too")){

            this.listenSet('2')
          }

         
          if(command.includes("3") || command.includes("three") || command.includes("tree")){     
           this.listenSet('3')
          }

          if(command.includes("4") || command.includes("four") || command.includes("for")){
            this.listenSet('4')
          }
          
        }


        //CHECK STATUS
          if(command.includes("show status") || command.includes("check status")){
            this.drawerOpen("showing status");
          }

          if(command.includes("close status") || command.includes("hide status")){
            this.drawerClose("closing status");
          }
        // Top Ten
        if(command.includes("show top 10") || command.includes("show tap 10")  || command.includes("check top 10") || command.includes("check top 10")){
          this.showTop()
          this.setState({topOpen:true})
         
        }

        if(command.includes("close top 10") || command.includes("close tap 10") || command.includes("hide top 10")|| command.includes("hide tap 10")){
          this.closeTop()
          this.setState({topOpen:false})
          
         }
          if(command.includes("open")){
           // if(command.includes("eth") || command.includes("ethereum") || command.includes("wan")){
              const i = command.toString()
              //this.affirmative();
              this.setState({openCommand:true},()=>console.log())
              this.checker(i.slice(5,60))
              //this.tagalogChart(i.slice(5,40))
              //this.state.chartDisplay_USD.push([this.state.coinChart,'USDT',(i.slice(5,20) + 'USDT'),false,i.slice(5,20)]);
              //setTimeout(()=>window.scrollTo(0,680),500); 
           // }
          }


          if(command.includes("remove") || command.includes("close chart")){
              const r = command.toString()
              this.setState({removeAsset:true},()=>console.log())
              this.checker(r.slice(7,50))            
          }

     
      if(command.includes("price")){
        const a = command.toString()
        findPrice=a.slice(6,40)
        this.setState({priceCommand:true},()=>console.log())
        this.checker(findPrice)
      }
     

      if(command.includes("anong presyo ni") || command.includes("anong presyo ng") ){
        const b = command.toString()
        presyo=b.slice(16,50)
        this.setState({priceCommand:true},()=>console.log())
        this.checker(presyo)
     
    }

    ///CURRENT TRADE
    if(command.includes("do we have a trade") || command.includes("may trade ba tayo")|| command.includes("current trade") || command.includes("whats our trade")){
      
      this.speakTrade()
      
     // this.listenFind();
     // window.scrollTo(0,670); 
  }

  if(command.includes("trade details") || command.includes("trade detail")|| command.includes("train details") || command.includes("train detail")){
    if(this.state.trade.length > 0){
    this.setState({tradeDetailRequest:true}); 
     }
     else{
       this.speakTrade()
     }
   // this.speakTrade()
    
   // this.listenFind();
   // window.scrollTo(0,670); 
}


if(command.includes("summary") || command.includes("summery")|| command.includes("summer") || command.includes("samer")){
  if(this.state.trade.length > 0){
  this.setState({requestSummary:true}); 
   }
   else{
    this.speakTrade()
   }
 // this.speakTrade()
  
 // this.listenFind();
 // window.scrollTo(0,670); 
}
  if(command.includes("find")  || command.includes("fine")  || command.includes("pine")){
    const current = this.state.CurrencyType;
    const a = command.toString()
    findAsset=a.slice(5,40)
    this.setState({findCommand:true},()=>console.log())
    this.checker(findAsset)
   
  } 


  //////////// START OFINPUT CONNANDS

  if(command.includes("enter") ){
    const tr = command.toString()
    chosenAsset=tr.slice(6,40)
    this.setState({chosenTrade:true},()=>console.log())
    this.checker(chosenAsset)  
  } 


  
  if(command.includes("entry")){

    const entry = command
    if(this.state.assetTrade !== undefined){
      this.setState({listenEntry:entry.slice(6,40).replaceAll(' ', '').replaceAll('point','.').replaceAll('one','1').replaceAll('to','2').replaceAll('three','3').replaceAll('for','4').replaceAll('five','5').replaceAll('six','6').replaceAll('seven','7').replaceAll('eigth','8').replaceAll('nine','9').replaceAll('zero','0').replaceAll(',','')
    },()=>console.log(this.state.listenEntry))
    }  
  
  }

  if(command.includes("amount")){
    const amount = command
    if(this.state.assetTrade !== undefined){
      this.setState({listenAmount:amount.slice(7,40).replaceAll(' ', '').replaceAll('point','.').replaceAll('one','1').replaceAll('to','2').replaceAll('three','3').replaceAll('for','4').replaceAll('five','5').replaceAll('six','6').replaceAll('seven','7').replaceAll('eigth','8').replaceAll('nine','9').replaceAll('zero','0').replaceAll(',','')
    },()=>console.log(this.state.listenAmount))
    }  
  
  }

  if(command.includes("target")){
    const target = command
    if(this.state.assetTrade !== undefined){
      this.setState({listenTarget:target.slice(7,40).replaceAll(' ', '').replaceAll('point','.').replaceAll('one','1').replaceAll('to','2').replaceAll('three','3').replaceAll('for','4').replaceAll('five','5').replaceAll('six','6').replaceAll('seven','7').replaceAll('eigth','8').replaceAll('nine','9').replaceAll('zero','0').replaceAll(',','')
    },()=>console.log(this.state.listenTarget))
    }  
  
  }

 ////////////// END OF INPUT CONNANDS

 if(command.includes("motoko")){
  this.motoko()  
} 

  if(command.includes("shut up")){
    this.abort()  
  } 

  
  if(command.includes("clear mind")){
    this.clearMind()  
  }
  
  if(command.includes("bigbang")){
    this.bigBang()  
  } 

  if(command.includes("gold digger")){
    let  textMessage = 'Executing Gold Digger Protocol'
    var u = new SpeechSynthesisUtterance('All is Ok');
     u.text = textMessage;  
     u.lang = 'en-US';   
     u.rate = .9;
     u.pitch = 1; 
     u.voice = UK;      
     speechSynthesis.speak(u);

    this.goldDigger() 
     
  } 
     
    }



    recognition.onend = (event) =>{
     recognition.start();
  }
//END OF COMMANDS
  





    let BTC_greed = 'cross';
    let ETH_greed = 'cross';
    let BTC_score = 0;
    let ETH_score = 0;
    if(this.state.BTC_Sentiment.sentiment === 'bearish'){
      BTC_greed = 'check'
      BTC_score = '53%';
    }
    else if(!this.state.BTC_Sentiment.sentiment === 'bearish'){
      BTC_score = '48%';
    }

    if(this.state.ETH_Sentiment.sentiment === 'bearish'){
      ETH_greed = 'check'
      ETH_score = '62%';
    }
    else if(!this.state.ETH_Sentiment.sentiment === 'bearish'){
      ETH_score = '42%';
    }

    let gaugeClose = () => this.setState({gaugeModalOpen:false})
    let gaugeOpen = () => this.setState({gaugeModalOpen:true})
   
    let loading = ''
    if(this.state.loading){
    loading = <div className="row">
         <h1 className="spin mt-5 large"><i class="fas fa-yin-yang"></i></h1>
         </div>}
    /*<div className="input-group input-group-xs col-lg-12">
        <div className="input-group-prepend ">
          <span className="input-group-text search-icon" id="inputGroup-sizing-sm"><i className="fa fa-search"></i>&nbsp;Search</span>
          </div>
        <input type="text" value={this.state.value} className="form-control" aria-label="Large" aria-describedby="inputGroup-sizing-sm" />
        
      </div>*/
    let backdrop;

    let topClose = () => this.setState({topOpen:false})
    let topOpen = () => this.setState({topOpen:true})

    if(this.state.sideDrawerOpen){
      
      backdrop=<Backdrop click={this.backdropClickHandler}/>;
    }

    let x = this.state.Coin.sort((a, b) =>  a.localeCompare(b))
    let option = '';  
    let buttonText = 'Next'

    if(this.state.setRangeFrom == 0){
      buttonText = 'Next'
    }
    else{
      buttonText = 'Previous'
    }

    if(this.state.setNumber == 2){
      option = <select onChange={this.changeUSD} className="options4">
                  <option value="USDT" key="1" className="options">USD</option>
						      <option value="BTC" key="2" className="options">BTC</option>
                  <option value="ETH" key="3" className="options">ETH</option>
               </select>   
    }
    
    else if(this.state.setNumber == 1) option = <select onChange={this.changeUSD} className="options4">
                    <option value="USDT" key="1" className="options">USD</option>
                    <option value="BTC" key="2" className="options">BTC</option>
                    <option value="ETH" key="3" className="options">ETH</option>
                  </select> 
                  
   else{
         option = <select onChange={this.changeUSD} className="options4">
                  <option value="USDT" key="1" className="options">USD</option>
                  <option value="BTC" key="2" className="options">BTC</option>
                  <option value="ETH" key="3" className="options">ETH</option>              
        </select>   
          }

 //console.log(this.state.chartDisplay)

 /* TRADITIONAL CHART

 {this.state.chartDisplay.map((chart,index)=>(
  <div class="column2" key={index}>
    <div className="cryptochart">
    <a className="links" id={chart[0] +'-'+ chart[1]}></a>
    <TradingViewWidget
symbol={"BITTREX:"+chart[2]}
theme={Themes.DARK}
locale="en"
hide_side_toolbar={false}
autosize
/>
    <div className="chart2"> <iframe src={"https://widget.coinlib.io/widget?type=chart&theme=dark&coin_id="+chart[0]+"&pref_coin_id="+chart[1]} width="100%" height="270px" scrolling="auto" marginwidth="0" marginheight="0" frameborder="0" border="0" ></iframe> </div>
    <h5 className="closeChart" onClick={()=>this.remove(chart)}> {this.getSlug(chart[0],chart[1])}</h5>
  </div>
  
  </div>))}*/


  /* COIN GUAGE
  
  <div className="totalMarketCap">
        <TechnicalAnalysis 
    symbol={"BTC"} 
    interval={TechnicalAnalysis.THEMES.ONE_HOUR,INTERVALS.ONE_WEEK,INTERVALS.ONE_MINUTE}
    colorTheme ={THEMES.DARK}
    autosize ={true}
    height={250}
    width={225}
/>
----symbol={"CRYPTOCAP:BTC.D"}-----
</div> */
//<Voice priceText={priceText}/>


  return (
   
    
    
    <div className="App">
      <Navbar></Navbar>
      <header className="App-header">

     
        <div className="row">
      
      <div className="cols mt-1">

        <SideDrawer show={this.state.sideDrawerOpen} lists={this.state.added} clear={this.clearList} 
        hide={this.drawerToggleClickHandler}/>
        {backdrop}

        <StatusDrawer show={this.state.statusDrawerOpen} lists={this.state.added} clear={this.clearList} 
        hide={this.statusToggleClickHandler}
        changeSet={this.changeSet}
        red={this.state.red}
        green={this.state.green}
        blue={this.state.blue}
        newsOpen={this.newsOpen}
        news={this.state.newsOpen}
        list={this.drawerToggleClickHandler}
        setNumber={this.state.setNumber}/>
      

        <select onChange={this.changeSet} value = {this.state.setNumber} className="options4 ml-3">
            <option value="1" key="1" className="options" >Set 1</option>
						<option value="2" key="2" className="options">Set 2</option>
            <option value="3" key="3" className="options">Set 3</option>
            <option value="4" key="4" className="options">Set 4</option>
        </select>   

        {option}

        <select onChange={this.changeTime} className="options4">
            <option value="histoday" key="1" className="options">Daily</option>
						<option value="histohour" key="2" className="options">Hourly</option>
        </select>  
         
        <select onChange={this.changeKey} className="options4">
            <option value="1" key="1" className="options" >key 1</option>
						<option value="2" key="2" className="options">Key 2</option>
            <option value="3" key="3" className="options">Key 3</option>
        </select>  
         
        <button className="options2" onClick={() => this.setState({ topOpen:true})}>
          <i class="fas fa-chess-queen"></i>
         </button>  

          
        <div className="form-group">
							<input type="text" autoComplete="off" onChange={this.findingCoin}/>
            
							<div className="input-group-prepend">
              <a href={"#"+this.state.findCoin.toUpperCase()+"-"+this.state.CurrencyType} className="anchor">	<span className="finder">Find Asset</span></a>
						
						</div>
					</div>

          
        <button className="topButton" onClick={this.statusToggleClickHandler}>
          <i class="fab fa-old-republic"></i>
        </button>

          {this.state.topOpen&&<TopCap
            show={topOpen}
            onHide={topClose}
            aria-labelledby="ModalHeader"
        />}
       	
        
			

            </div>
          </div>     
        <div>
      </div> 

   
        


<div className="row">

<div class="column3" >
  <div className="sentiment">
  <img src={bitcoin} className="logoCard" alt=''/>
  <h5> BITCOIN Greed Index</h5>
  <p className = {BTC_greed}>{BTC_score}</p>
</div>
</div>

<div class="column3" >
  <div className="sentiment">
  <img src={ethereum} className="logoCard" alt=''/>
  <h5> ETHEREUM Greed Index</h5>
  <p className = {ETH_greed}>{ETH_score}</p>
</div>
</div>

<div class="column3" >
  <div className="sentiment">
  <img src={uniswap} className="logoCard" alt=''/>
  <h5> DEFI Market Cap</h5>
  
  <p>${this.state.Defi_Cap.slice(0,2)}.{this.state.Defi_Cap.slice(2,3)}b</p>
</div>
</div>

</div>


<div className="row">

<div class="column5" >
  <div className="golddig">
  <h5> No. of Trades</h5> 
  <p>{this.state.historicalTrade.length}</p>
</div>
</div>

<div class="column5" >
  <div className="golddig">
  <h5> Balance</h5>
  <p>${numeral(this.state.capital).format('0,0.00')}</p>
</div>
</div>

<div class="column5" >
  <div className="golddig">
  <h5> On Trade</h5>
  <p>${numeral(this.state.onSpent).format('0,0.00')}</p>
</div>
</div>

<div class="column5" >
  <div className="golddig">
  <h5> Profit</h5>
  <p>${numeral((this.state.onSpent + this.state.capital)-200).format('0,0.00')}</p>
</div>
</div>

<div class="column5" >
  <div className="golddig">
  <h5> Next Scan</h5> 
  <p>{this.state.time.minutes}:{this.state.time.seconds}</p>
</div>
</div>

<div class="column5" >
  <div className="golddigHistory">
  <h5> Trade History</h5> 
{this.state.historicalTrade.map((history,index)=>(<p>{index + 1}. {history[0] } - ${numeral(history[1]).format('0,0.00')} - Time: {history[5]}:{history[6]}</p>))}
</div>
</div>

</div>

<div className="row">

<div class="column5" >
<select onChange={this.changeScanColor} defaultValue="signal" className="golddigOptions">
    <option value="" className="options" disabled>Select a signal</option>
    <option value="green" key="2" className="options">Green</option>
    <option value="blue" key="3" className="options">Blue</option>
    <option value="red" key="4" className="options" >Red</option>
		
</select>  
</div>

<div class="column5" >
<select onChange={this.changeTarget} className="golddigOptions">
    <option value='1' key="1" className="options" disabled>Target Percentage</option>
    <option value={0.03} key="2" className="options" >3%</option>
		<option value={0.05} key="3" className="options">5%</option>
    <option value={0.10} key="4" className="options">10%</option>
    <option value={0.20} key="5" className="options">20%</option>
</select>  
</div>

<div class="column5" >
<select onChange={this.changeTradeDuration} className="golddigOptions">
<option value='1' key="0" className="options" disabled>Trade duration</option>
    <option value={5 * 60 * 1000} key="6" className="options" >5 min.</option>
    <option value={10 * 60 * 1000} key="1" className="options" >10 min.</option>
		<option value={15 * 60 * 1000} key="2" className="options">15 min.</option>
    <option value={20 * 60 * 1000} key="3" className="options">20 min.</option>
    <option value={30 * 60 * 1000} key="4" className="options">30 min.</option>
    <option value={60 * 60 * 1000} key="5" className="options">60 min.</option>
</select>  
</div>

<div class="column5" >
<select  className="golddigOptions">
    <option value="1" key="1" className="options" >Red</option>
		<option value="2" key="2" className="options">Green</option>
    <option value="3" key="3" className="options">Blue</option>
</select>  
</div>

<div class="column5" >
<select onChange={this.changeTradeDuration} className="golddigOptions">
<option value='1' key="0" className="options" disabled>Scan Interval</option>
    <option value={10 * 60 * 1000} key="1" className="options" >10 min.</option>
		<option value={15 * 60 * 1000} key="2" className="options">15 min.</option>
    <option value={20 * 60 * 1000} key="3" className="options">20 min.</option>
    <option value={30 * 60 * 1000} key="4" className="options">30 min.</option>
    <option value={60 * 60 * 1000} key="5" className="options">60 min.</option>
</select>  
</div>

<div class="column5" >
<select onChange={this.changeReset} className="golddigOptions">
<option value='1' key="1" className="options" disabled>Reset Trades</option>
    <option value="0" key="1" className="options" >0 trade</option>
		<option value="1" key="2" className="options">1 trade</option>
    <option value="2" key="3" className="options">2 trades</option>
    <option value="3" key="4" className="options" >3 trades</option>
		<option value="4" key="5" className="options">4 trades</option>
    <option value="5" key="6" className="options">5 trades</option>
    <option value="6" key="7" className="options">6 trades</option>
    <option value="7" key="8" className="options" >7 trades</option>
		<option value="8" key="9" className="options">8 trades</option>
    <option value="9" key="10" className="options">9 trades</option>
    <option value="10" key="11" className="options">10 trades</option>
</select>  
</div>

</div>


     
         <div className="totalMarketCap">
        
         <TradingViewWidget
          symbol={"BINANCE:BTCUSDT"}
          theme={Themes.DARK}
          locale="en"
          hide_side_toolbar={false}
          details={false}
          withdateranges={false}
          hide_legend={true}
          show_popup_button={true}
          popup_width={1000} 
          popup_height={600}
          style={3}
          toolbar_bg= "#fafa"
          studies="BB@tv-basicstudies"
          autosize
          /> 
        
        </div> 
        <div className="row">
        {this.state.trade.length > 0 && this.state.trade.map((trade,index)=>(
        <div class="column2" key = {index} id={trade[1]+'~'+trade[2]}>
        <a className="links" id={trade[1] +'~'+ trade[2]}><TradeCard trade = {trade} 
        tradePrice = {this.state.tradePrice}
        removeTrade = {this.removeTrade}
        tradeDetailRequest = {this.state.tradeDetailRequest}
        speakTradeDetails = {this.speakTradeDetails}
        requestSummary = {this.state.requestSummary}
        summaryRequest = {this.summaryRequest}

        listenEntry ={this.state.listenEntry}
        listenAmount ={this.state.listenAmount}
        listenTarget ={this.state.listenTarget}
        assetTrade = {this.state.assetTrade}
        oblivion = {this.oblivion}
        position = {index}

        //GOLD DIGGER PROTOCOL
        onTrade = {this.state.onTrade}
        onSpent = {this.state.onSpent}
        capital = {this.state.capital}
        currentGold = {this.state.currentGold}
        targetPercent = {this.state.targetPercent} 
        tradeDuration = {this.state.tradeDuration}

        sell = {this.sell}

        /></a>
        </div>))}
        </div>

        <div className="row">

{this.state.chartDisplay_USD.map((chart,index)=>(
 
 <div class="column2" key={index}>
  <a className="links" id={chart[4] +'X'+ chart[1]}>
  <div className="cryptochart">
 
  <div className="chart2"> 
  
  <TradingViewWidget
  symbol={"BINANCE:"+chart[2]}
  theme={Themes.DARK}
  locale="en"
  hide_side_toolbar={false}
  details={false}
  withdateranges={false}
  hide_legend={true}
  show_popup_button={true}
  popup_width={1000} 
  popup_height={600}
  
  
  autosize
  
  studies={this.state.studies}
  />  
  </div>
 
  <div class="dash" onClick={() => this.setState({ gaugeModalOpen:true,gaugeCoin:chart[4]})}>
  <i class="fas fa-power-off"></i>
  

  </div>

  <h5 className="closeChart" onClick={()=>this.removeUSD(chart)}> {chart[4]} - {this.getSlug(chart[1])} </h5>
  
</div>
</a>

<a className="links" id={chart[0] +'- BTC'}>
  <div className="cryptochart">
 
  <div className="chart2"> 
  
  <TradingViewWidget
  symbol={"BINANCE:"+chart[4]+'BTC'}
  theme={Themes.DARK}
  locale="en"
  hide_side_toolbar={false}
  details={false}
  withdateranges={false}
  hide_legend={true}
  show_popup_button={true}
  popup_width={1000} 
  popup_height={600}
  
  
  autosize
  
  studies={this.state.studies}
  />  
  </div>
 
  <div class="dash" onClick={() => this.setState({ gaugeModalOpen:true,gaugeCoin:chart[4]})}>
  <i class="fas fa-power-off"></i>
  

  </div>

  <h5 className="closeChart" onClick={()=>this.removeUSD(chart)}> {chart[4]} - {this.getSlug('BTC')} </h5>
  
</div>
</a>

</div>))}


{this.state.chartDisplay.map((chart,index)=>(
 
 <div class="column2" key={index}>
  <a className="links" id={chart[0] +'-'+ chart[1]}>
  <div className="cryptochart">
 
  <div className="chart2"> 
  
  <TradingViewWidget
  symbol={"BINANCE:"+chart[2]}
  theme={Themes.DARK}
  locale="en"
  hide_side_toolbar={false}
  details={false}
  withdateranges={false}
  hide_legend={true}
  show_popup_button={true}
  popup_width={1000} 
  popup_height={600}
  autosize
  
  studies={this.state.studies}
  />  
  </div>
 
  <div class="dash" onClick={() => this.setState({ gaugeModalOpen:true,gaugeCoin:chart[4]})}>
  <i class="fas fa-power-off"></i>
  

  </div>

  <h5 className="closeChart" onClick={()=>this.remove(chart)}> {chart[4]} - {this.getSlug(chart[1])} </h5>
  
</div>
</a>

</div>))}

{this.state.gaugeModalOpen &&<GaugeModal
  show={gaugeOpen}
  onHide={gaugeClose}
  coinName={this.state.gaugeCoin}/>}

</div>
        
          
         
       {this.state.newsOpen &&<div className="row">

        {this.state.news.map((news,index)=>(
        <div class="column3" key={index}>
          <div className="cryptoNews">
          <img className="newsImage2" src={news.project.image.large} scrolling="auto" marginwidth="0" marginheight="0" frameborder="0" border="0" ></img>
          <p className="news2" >{news.description}</p>
          <h5 className="closeChart"> {news.project.name}</h5>
        </div>
        
        </div>))}

        </div>}



        {!this.state.newsOpen && <div className="row">

      {this.state.Coin.map((list,index)=>(
        <div class="column" key={index}>
          <a className="links" id={list +'-'+ this.state.CurrencyType}>
          <CryptoCard coin={list} 
          message={this.state.message}
          currency={this.state.CurrencyType}
          price={this.state.currentPrice[list]}
          time={this.state.TimeFrame}
          add={this.addCoin}
          enterTrade={this.enterTrade} 
          trade={this.state.trade}
          prevTrade = {this.prevTrade}
          key={index} 

          red={this.state.red}
          green={this.state.green}
          blue={this.state.blue}
          locked={this.state.locked}

          chartDisplay={this.state.chartDisplay}
          chartDisplay_USD={this.state.chartDisplay_USD}
          apiKey={apiKey}
          findPrice={findPrice}
          speakPrice={this.speakPrice}
         />
          </a>
        </div>
      ))}
      </div>}
      </header>
    </div>
  );
}



componentDidMount() {
  this._isMounted = true;
  this.getPrice();
  this.getSentiment();
 // this.startTimer()
 
 // this.binance();
 // this.free();
 
  
 const allVoicesObtained = new Promise(function(resolve, reject) {
  let voices = window.speechSynthesis.getVoices();
  if (voices.length !== 0) {
    resolve(voices);
  } else {
    window.speechSynthesis.addEventListener("voiceschanged", function() {
      voices = window.speechSynthesis.getVoices();
      resolve(voices);
      UK=voices[5];
    });
  }
});

allVoicesObtained.then(voices => console.log("All voices:", voices));


 
  
}

componentDidUpdate(prevProps, prevState) {
  if(prevState.chartDisplay !== this.state.chartDisplay){
   
  }

  if(prevState.trade!== this.state.trade){
   
  }

  if(prevState.trade.length!== this.state.trade.length){
   
  }
  
}

componentWillUnmount() {
this._isMounted = false;
}

}


export default App;
